export const firstLetterCapitalize = (s: string): string => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const flc = (s: string): string => {
    return firstLetterCapitalize(s);
};
